import { useId } from "react";
import { motion, useReducedMotion } from "framer-motion";

export function Sparkline({ data = [], up = true, width = 96, height = 36 }) {
  const gradId = useId();
  const reduced = useReducedMotion();
  if (!data || data.length < 2) {
    return <div style={{ width, height }} />;
  }
  const min = Math.min(...data);
  const max = Math.max(...data);
  const range = max - min || 1;
  const step = width / (data.length - 1);
  const points = data
    .map((v, i) => {
      const x = i * step;
      const y = height - ((v - min) / range) * (height - 4) - 2;
      return `${x.toFixed(2)},${y.toFixed(2)}`;
    })
    .join(" ");
  const color = up ? "#00E676" : "#FF3B30";
  return (
    <svg width={width} height={height} className="overflow-visible">
      <defs>
        <linearGradient id={gradId} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={color} stopOpacity="0.35" />
          <stop offset="100%" stopColor={color} stopOpacity="0" />
        </linearGradient>
      </defs>
      <motion.polyline
        animate={{ points }}
        initial={false}
        transition={{ duration: reduced ? 0 : 0.35 }}
        fill="none"
        stroke={color}
        strokeWidth="1.6"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
      <polygon points={`0,${height} ${points} ${width},${height}`} fill={`url(#${gradId})`} />
    </svg>
  );
}
